export default __webpack_public_path__ + "static/media/8.9f1aad67.svg";